import React from 'react';
import { useNavigate } from 'react-router-dom';
import { mixed, object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Form, { Ajuda, Campo, Editor } from 'Component/Form';
import Solicitacao from 'Interface/Solicitacoes';
import { useAdicionarSolicitacaoMutation } from 'View/Service/Default/Solicitacoes';

const regras = object({
  titulo: string().required('Obrigatório'),
  descricao: mixed().test('obrigatorio', 'Obrigatório', (valor) => {
    if (valor?.blocks?.length && valor.blocks[0].text) {
      return true;
    }

    return false;
  }),
});

const Adicionar = (): React.ReactElement => {
  const toast = useToast();
  const navegacao = useNavigate();
  const [adicionarSolicitacao] = useAdicionarSolicitacaoMutation();

  const enviar = async (solicitacao: Solicitacao): Promise<void> => {
    try {
      await adicionarSolicitacao(solicitacao).unwrap();

      toast({
        tema: 'success',
        conteudo: 'Solicitação aberta com sucesso!',
      });

      navegacao('/estudar/solicitacoes');
    } catch (erro) {
      toast({
        titulo: 'Erro ao abrir a solicitação',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="animate__animated animate__fadeIn" style={{ minHeight: window.outerHeight }}>
      <div
        className="hf-400 d-flex align-items-end pb-5"
        style={{
          backgroundImage:
            'linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 100%), url(/img/meus-cursos.jpg)',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          marginTop: '-130px',
        }}
      >
        <div className="container text-center">
          <h1 className="display-2 text-white">Abrir solicitação</h1>
          <p className="lead text-muted">
            Conte para nós o que está acontecendo para que possamos te ajudar!
          </p>
        </div>
      </div>
      <div className="mx-3">
        <div className="container mb-5">
          <div className="row justify-content-center">
            <div className="col-sm-5">
              <div className="bg-white rounded-3 p-3">
                <Form regras={regras} onSubmit={enviar}>
                  <Campo name="titulo" rotulo="Título ou assunto" />
                  <Editor name="descricao" rotulo="Descrição" />
                  <div className="mt-n3">
                    <Ajuda>O prazo para resposta é de até 48 horas úteis.</Ajuda>
                  </div>
                  <div className="d-flex justify-content-end mt-3">
                    <BotaoLink
                      tema="light"
                      to="/estudar/solicitacoes"
                      texto="Cancelar"
                      className="me-1"
                    />
                    <Botao type="submit" texto="Enviar" />
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Adicionar;
